import { styled } from '@mui/material/styles';
import { ChartsLabelMark, labelMarkClasses } from '@mui/x-charts/ChartsLabel';
import React from 'react';

import { useChartPalette } from 'components/charts/hooks/use-chart-palette';
import { seriesStyle } from 'views/benchmark-analytics/utils/series-style';

type SeriesMarkerProps = {
  // Palette slot, see COMPANY_SLOT, MARKET_SLOT and FIRST_FARM_SLOT.
  slot: number;
  size?: number;
};

const MarkerRoot = styled('span', {
  shouldForwardProp: (prop) => prop !== 'size',
})<{ size: number }>(({ size }) => ({
  display: 'inline-flex',
  flexShrink: 0,
  width: size,
  height: size,

  [`& .${labelMarkClasses.root}`]: {
    width: '100%',
    height: '100%',
  },
}));

// The only component that draws a series marker outside the chart: same glyph as the chart legend, color and shape from seriesStyle.
const SeriesMarker: React.FC<SeriesMarkerProps> = ({ slot, size = 14 }) => {
  const palette = useChartPalette();
  const style = seriesStyle(slot, palette.series.categorical);

  return (
    <MarkerRoot size={size} aria-hidden>
      <ChartsLabelMark type="line+mark" markShape={style.shape} color={style.color} />
    </MarkerRoot>
  );
};

export default SeriesMarker;
